import styled from 'styled-components';
import { color, gutter } from '../../styles/mixins';
import { caps12 } from '../../styles/typography';

export const Th = styled.th`
  ${caps12};
  padding: 19px ${gutter(1)};

  text-transform: uppercase;
  text-align: left;

  color: ${color('gray80')};
  border-bottom: 1px solid ${color('gray30')};
`;
